import { Injectable, inject } from '@angular/core';
import { LoDialogService } from 'lo-design-system';
import { map, Observable } from 'rxjs';
import { InviteMemberDialogComponent } from './invite-member-dialog.component';
import {
	InviteMemberDialogData,
	InviteMemberDialogResult
} from './invite-member-dialog.model';

@Injectable({ providedIn: 'root' })
export class InviteMemberDialogService {
	private readonly dialogs = inject(LoDialogService);

	open(
		data: InviteMemberDialogData,
		opener?: HTMLElement | null
	): Observable<InviteMemberDialogResult> {
		const ref = this.dialogs.open<
			InviteMemberDialogComponent,
			InviteMemberDialogData,
			InviteMemberDialogResult
		>(InviteMemberDialogComponent, {
			data,
			opener: opener ?? undefined
		});
		return ref.closed.pipe(map(result => result ?? { invited: false }));
	}
}
